import { render, staticRenderFns } from "./Sustainability.vue?vue&type=template&id=e950bbde&scoped=true&"
import script from "./Sustainability.vue?vue&type=script&lang=js&"
export * from "./Sustainability.vue?vue&type=script&lang=js&"
import style0 from "./Sustainability.vue?vue&type=style&index=0&id=e950bbde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e950bbde",
  null
  
)

export default component.exports